(() => {
  const selector = '[data-gpd-products]';

  const initialize = (root) => {
    if (!root || root.dataset.loadMoreReady === 'true') return;
    const button = root.querySelector('[data-gpd-load-more]');
    const grid = root.querySelector('[data-gpd-product-grid]');
    if (!button || !grid) return;

    root.dataset.loadMoreReady = 'true';
    const status = root.querySelector('[data-gpd-load-more-status]');

    button.addEventListener('click', async () => {
      if (button.disabled || !button.dataset.nextUrl) return;
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      root.classList.add('gpd-products--loading');
      if (status) status.textContent = 'Cargando más productos.';

      try {
        const url = new URL(button.dataset.nextUrl, window.location.origin);
        url.searchParams.set('section_id', root.dataset.sectionId);
        const response = await fetch(url.toString(), { headers: { Accept: 'text/html' } });
        if (!response.ok) throw new Error(`HTTP ${response.status}`);

        const documentFragment = new DOMParser().parseFromString(await response.text(), 'text/html');
        const incomingGrid = documentFragment.querySelector('[data-gpd-product-grid]');
        if (!incomingGrid) throw new Error('No se encontró la siguiente cuadrícula de productos.');

        const newCards = Array.from(incomingGrid.children);
        newCards.forEach((card) => grid.appendChild(card));
        const nextButton = documentFragment.querySelector('[data-gpd-load-more]');
        button.dataset.nextUrl = nextButton?.dataset.nextUrl || '';

        if (!button.dataset.nextUrl) button.closest('.gpd-products__load-more-wrap')?.remove();
        if (status) {
          status.textContent = `Se cargaron ${newCards.length} productos. ${grid.children.length} de ${root.dataset.productTotal} visibles.`;
        }
      } catch (error) {
        button.disabled = false;
        if (status) status.textContent = 'No fue posible cargar más productos. Intenta nuevamente.';
        console.error('[GPD products] Load more failed', error);
      } finally {
        button.removeAttribute('aria-busy');
        root.classList.remove('gpd-products--loading');
        if (button.isConnected && button.dataset.nextUrl) button.disabled = false;
      }
    });
  };

  const initializeAll = (scope = document) => scope.querySelectorAll(selector).forEach(initialize);
  document.addEventListener('DOMContentLoaded', () => initializeAll());
  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
